{
  "Account": "Compte",
  "Account linked": "Compte relié",
  "Actions": "Actions",
  "Active or departed": "Tous",
  "Add them": "Les ajouter",
  "Administration": "Administration",
  "Agencies": "Agences",
  "Agency": "Agence",
  "Agency · unit": "Agence · pôle",
  "All agencies": "Toutes les agences",
  "All job titles": "Tous les intitulés",
  "All units": "Tous les pôles",
  "An active person is assignable if they match every checked dimension (job title, unit, agency); a dimension with no box checked constrains nothing; an excluded state always rules out. The per-person override takes precedence over the rule.": "Une personne active est assignable si elle correspond à chaque dimension cochée (intitulé, pôle, agence) ; une dimension sans case cochée ne contraint rien ; un état exclu écarte toujours. Le forçage par personne l'emporte sur la règle.",
  "Assignability": "Assignabilité",
  "Assignability rule": "Règle d'assignabilité",
  "Assignable": "Assignable",
  "Assignable or not": "Assignables ou non",
  "Assignable people": "Assignables",
  "Boond person": "Personne Boond",
  "Boond state": "État Boond",
  "Boond sync": "Synchronisation Boond",
  "Cancel": "Annuler",
  "Conflicts and errors": "Conflits et erreurs",
  "Current assignments": "Affectations en cours",
  "Daily sync at <0>{{time}}</0> (Paris time)": "Synchronisation quotidienne à <0>{{time}}</0> (heure de Paris)",
  "Departed": "Parti",
  "Departed (OFF in Boond or removed)": "Partis (OFF dans Boond ou retirés)",
  "Discard changes": "Annuler les changements",
  "Email": "Email",
  "Every signed-in account is linked.": "Tous les comptes connectés sont reliés.",
  "Excluded Boond states": "États Boond exclus",
  "Filter people": "Filtrer les personnes",
  "Filter: {{legend}}": "Filtrer : {{legend}}",
  "Filter…": "Filtrer…",
  "How the rule applies": "Comment la règle s'applique",
  "Incomplete walk: {{detail}}": "Parcours incomplet : {{detail}}",
  "It starts on the next run of the scheduled job (10 min at most).": "Elle démarre au prochain passage de la tâche planifiée (10 min au plus).",
  "Job title": "Intitulé",
  "Job titles": "Intitulés",
  "Last attempt": "Dernière tentative",
  "Link": "Relier",
  "Link an account": "Relier un compte",
  "Link to a person<0>: {{who}}</0>": "Relier à une personne<0> : {{who}}</0>",
  "Linked": "Relié",
  "Loading people…": "Chargement des personnes…",
  "Loading the rule…": "Chargement de la règle…",
  "Name": "Nom",
  "Name, email or job title…": "Nom, email ou intitulé…",
  "Next": "Suivant",
  "No assignment": "Aucune",
  "No constraint": "Aucune contrainte",
  "No one matches": "Personne ne correspond",
  "No pending account": "Aucun compte en attente",
  "No sync yet": "Aucune synchronisation",
  "No value.": "Aucune valeur.",
  "Non-assignable people": "Non assignables",
  "Not assignable": "Non assignable",
  "Not linked": "Non relié",
  "Override": "Forçage",
  "Override for {{name}}": "Forçage de {{name}}",
  "Override saved": "Forçage enregistré",
  "People": "Personnes",
  "People pagination": "Pagination des personnes",
  "Person": "Personne",
  "Presence in Boond": "Présence dans Boond",
  "Present": "Présents",
  "Previous": "Précédent",
  "Result": "Résultat",
  "Rule saved": "Règle enregistrée",
  "SSO accounts that signed in without matching an active Boond person (different email, alias…). They see the “unlinked account” page until they are linked.": "Comptes SSO connectés sans correspondance avec une personne Boond active (email différent, alias…). Ils voient la page « compte non relié » tant qu'ils ne sont pas reliés.",
  "Save the rule": "Enregistrer la règle",
  "Scheduled sync paused": "Synchronisation planifiée en pause",
  "Search for a person": "Rechercher une personne",
  "Shared email {{email}} (Boond {{ids}})": "Email partagé {{email}} (Boond {{ids}})",
  "Start": "Début",
  "State {{value}}": "État {{value}}",
  "Sync now": "Synchroniser maintenant",
  "Sync requested": "Synchronisation demandée",
  "Sync requested on {{date}}: waiting for the next run.": "Synchronisation demandée le {{date}} : en attente du prochain passage.",
  "The first run will create the people from Boond.": "Le premier passage créera les personnes depuis Boond.",
  "The people synced from Boond, the rule that decides who is assignable, the accounts to link and the sync.": "Les personnes synchronisées depuis Boond, la règle qui décide qui est assignable, les comptes à relier et la synchronisation.",
  "These Boond job titles are not in the rule: the people who hold them are not assignable.": "Ces intitulés Boond ne figurent pas dans la règle : les personnes qui les portent ne sont pas assignables.",
  "Trigger": "Déclenchement",
  "Unit": "Pôle",
  "Units": "Pôles",
  "Unlinked accounts": "Comptes non reliés",
  "Useful when the SSO email differs from the Boond one.": "Utile quand l'email SSO diffère de celui de Boond.",
  "Widen the filters.": "Élargissez les filtres.",
  "no email": "sans email",
  "paused: only manual requests go through.": "en pause : seules les demandes manuelles passent.",
  "{{count}} assignability changed": "{{count}} assignabilité changée",
  "{{count}} created": "{{count}} créées",
  "{{count}} deactivated": "{{count}} désactivées",
  "{{count}} people changed status._one": "{{count}} personne a changé de statut.",
  "{{count}} people changed status._other": "{{count}} personnes ont changé de statut.",
  "{{count}} reactivated": "{{count}} réactivées",
  "{{count}} seen": "{{count}} vues",
  "{{count}} selected": "{{count}} retenu(s)",
  "{{count}} unclassified": "{{count}} non classé(s)",
  "{{count}} unclassified job titles_one": "{{count}} intitulé non classé",
  "{{count}} unclassified job titles_other": "{{count}} intitulés non classés",
  "{{count}} updated": "{{count}} mises à jour",
  "{{from}}–{{to}} of {{total}}": "{{from}}–{{to}} sur {{total}}",
  "{{name}}: assignable.": "{{name}} : assignable.",
  "{{name}}: not assignable.": "{{name}} : non assignable.",
  "{{value}} (not in Boond)": "{{value}} (absent de Boond)"
}
